import React from "react";
import ReactDOM from "react-dom"
import "../date.format.js";
import TermGroup from "./TermGroup.jsx";
import AcademyGroup from "./AcademyGroup.jsx";
import { ChildrenEditor } from "./ChildrenEditor.jsx";
import { Provider, connect } from "react-redux";
import { TERM_DATA } from "../termData.js";

import getStore, { setInsurance } from "./store";

function FlexiSelector(props) {
    return <React.Fragment>
        <fieldset className={"choose-days" + (props.discount > 0 ? " discount-added" : "")}>
            {props.activeTerms.map((term, idx) => (
                <TermGroup
                    idx={idx}
                    key={idx}
                    label={term.name}
                    discount={ props.discount.discountJson.find( e => e.name == term.name && (e.cutoff == null || (new Date() < new Date(e.cutoff)) )) }
                    from={term.from}
                    to={term.to}
                    days={Object.keys(props.store.getState().days).filter(d => {
                        let dd = new Date(d);
                        return dd >= term.from && dd <= term.to
                    })}
                />
            )
            )}
        </fieldset>
        <div className="checkbox-container" style={props.insurance == 0  ? { display: "none" } : null} >
            <FlexiInsurance insurance={props.insurance} />
        </div>
        <div className="breakout-container checkbox-container">
            <FlexiCheckbox />
        </div>

        <FlexiOptions />
        <FlexiTotal discount={props.discount} insurance={props.insurance} />

        
    </React.Fragment>
}

function FlexiAcademy(props) {
    const extraItems = props.store.getState().items.map(i => i.extras).reduce((a, b) => a.concat(b), []);
    let perDay = props.store.getState().items.concat(extraItems).map(item => item.price).reduce((a, b) => a + b, 0).toFixed(2);
    return <React.Fragment>
        <fieldset className="choose-days">
            <br />
            {props.activeTerms.map((term, idx) => (
                <AcademyGroup
                    idx={idx}
                    key={idx}
                    label={term.name}
                    discount={ props.discount.discountJson.find( e => e.name == term.name && (e.cutoff == null || (new Date() < new Date(e.cutoff)) )) }
                    from={term.from}
                    to={term.to}
                    days={Object.keys(props.store.getState().days).filter(d => {
                        let dd = new Date(d);
                        return dd >= term.from && dd <= term.to
                    })}
                    perDay={perDay}
                    types={props.store.getState().items.concat(props.store.getState().items.map(i => i.extras).reduce((a, b) => a.concat(b), [])).map(i => i.id)}
                />
            )
            )}
        </fieldset>
        <div className="checkbox-container" style={props.insurance == 0  ? { display: "none" } : null} >
            <FlexiInsurance insurance={props.insurance} />
        </div>
        <div className="breakout-container checkbox-container">
            <FlexiCheckbox />
        </div>

        <FlexiOptions />
        <FlexiTotal discount={props.discount} insurance={props.insurance} />
        
    </React.Fragment>
}

const FlexiCheckbox = function(){
    return <div className="check-confirmations">
						
        <div className="grid-container smaller">

            <div className="confirm">
                <div className="i-group">
                    <input type="checkbox" name="photo_permission" id="photo_permission" value="yes" defaultChecked />
                    <label htmlFor="photo_permission"><span>I consent for Active Superstars to take photos for the sole purpose of promoting its courses</span></label>
                </div>
            </div>

            <div className="confirm">
                <div className="i-group">
                    <input type="checkbox" name="communication_permission" id="communication_permission" value="yes" />
                    <label htmlFor="communication_permission"><span>I would like to receive course updates and exclusive offers</span></label>
                </div>
            </div>

            <div className="confirm">
                <div className="i-group">
                    <input type="checkbox" name="confirm" id="confirm" value="yes" />
                    <label htmlFor="confirm"><span>I confirm that I have read and agree with the following <a href="/Terms.html" target="_blank">Terms & Conditions</a></span></label>
                </div>
            </div>
            
        </div>
        
    </div>
}

const FlexiInsurance = connect( state => (
    {
        includeInsurance: state.includeInsurance,
        totalDays: Object.values(state.days).filter(d => Object.keys(d).find(k => d[k])).length,
        children: state.children
    }
), {
    setInsurance
})( ({ setInsurance, includeInsurance, insurance, totalDays, children }) => (
    <div className="check-insurance">
						
        <div className="grid-container smaller">
            <h3>Would you like to add our Customer Protection Plan?</h3>
            <p>With our optional Customer Protection Plan, you&apos;ll be refunded for any days missed due to illness or injury - or we can move your dates for free. <a href="/TandCS.html" target="_blank">See CPP for full details.</a></p>
            
            <div className="confirm">
                <div className="i-group">
                    <input 
                        type="checkbox" 
                        name="insurance-confirm" 
                        id="insurance-confirm" 
                        value="yes" 
                        checked={includeInsurance}
                        onChange={ ev => setInsurance(ev.target.checked) }
                    />
                    <label htmlFor="insurance-confirm"><span>Add to my booking (&pound;{parseFloat(insurance).toFixed(2)} x {totalDays} days x {children} children = &pound;{ (insurance * totalDays * children).toFixed(2) }){/* Price, days and children needs to be dynamic */}</span></label>
                </div>
            </div>
            
        </div>
        
    </div>
)
)

const FlexiOptions = connect(state => {
    const extraItems = state.items.map(i => i.extras).reduce((a, b) => a.concat(b), []);
    return {
        includeInsurance: state.includeInsurance,
        totalDays: Object.values(state.days).filter(d => Object.keys(d).find(k => d[k])).length,
        extras: extraItems.map(exItem => {
            return [exItem.name, Object.values(state.days).filter(d => d[exItem.id]).length]
        }),
        children: state.children
    }
})(props => <div className="chosen-options">

    <div className="days">
        <div className="icon">
            <img src="/Templates/steps2sport/images/dates.png" alt="Active Superstars Ltd" />
        </div>
        <div className="info">{props.totalDays}&nbsp;days</div>
    </div>
    <div className="plus" style={{ display: props.extras.length > 0 ? undefined : "none" }}>
        <img src="/Templates/steps2sport/images/plus.png" alt="Active Superstars Ltd" />
    </div>
    <div className="pickups-dropoffs" style={{ display: props.extras.length > 0 ? undefined : "none" }}>
        <div className="icon"></div>
        <div className="info">
            {props.extras.map(([name, total]) => [<span key={name} className="drop-offs">{total}&nbsp;&times;&nbsp;{name}</span>, <br key={name + "-br"} />])}
        </div>
    </div>

    { props.includeInsurance && <React.Fragment>
        <div className="plus">
            <img src="/Templates/steps2sport/images/plus.png" alt="Active Superstars Ltd" />
        </div>

        <div className="insurance">
            <div className="icon"></div>
            <div className="info">
            Customer Protection Plan
            </div>
        </div>
    </React.Fragment>}

    <div className="multply">
        <img src="/Templates/steps2sport/images/multiply.png" alt="Active Superstars Ltd" />
    </div>

    <div className="num-children">
        <div className="icon">
            <img src="/Templates/steps2sport/images/child.png" alt="Active Superstars Ltd" />
        </div>
        <div className="info">{props.children}&nbsp;child{props.children != 1 ? "ren" : ""}</div>
    </div>

</div>)

const FlexiTotal = connect((state, ownProps) => {
    let { discount } = ownProps;
    const extraItems = state.items.map(i => i.extras).reduce((a, b) => a.concat(b), []);

    let conDet = {};
    let total = 0;
    let totalWithDiscount = (
        state.items
            .concat(extraItems)
            .map(
                item => {
                    return Object.entries(state.days)
                        .filter(([_, types]) => types[item.id])
                        .map(([date, _]) => {
                            let percentageOfPrice = 1;
                            let currentDate = new Date(date);

                            //Find the activate discount JSON where this date is within that time, and the cutoff isn't active.
                            let selectedDiscountJSON = discount.discountJson.find( entry =>{
                                let from = new Date(entry.from);
                                let to = new Date(entry.to + "T23:59:59");
                                let today = new Date();
                                return currentDate >= from && currentDate <= to && (entry.cutoff == null || today < new Date(entry.cutoff));
                            });

                            // console.log("Found discount term", selectedDiscountJSON);

                            if( selectedDiscountJSON != null){
                                //TODO: Process
                                if (selectedDiscountJSON.type == "early") {//Take percentage off if an early bird discount and before that date
                                    percentageOfPrice -= (selectedDiscountJSON.discount / 100);
                                }

                                if(selectedDiscountJSON.type == "sibling") {
                                    if (state.children > 1) {
                                        percentageOfPrice -= (selectedDiscountJSON.discount / 100);
                                    }
                                }

                                if (selectedDiscountJSON.type == "consecutive") {
                                    let yearWeekKey = currentDate.format("o_W");

                                    let isFullWeek = Object.entries(state.days) //Iterate all days
                                        .filter(([date]) => (new Date(date)).format("o_W") == yearWeekKey) //Filter to days in this week
                                        .reduce((c, [_, types]) => { //Reduce to count of valid dates
                                            return c + (
                                                (
                                                    Object.values(types).filter(f => f).length > 0  //Look for any types on that date that are set
                                                ) ? 1 : 0 //Convert boolean to integer
                                            );
                                        }, 0) == 5;
                                    if (isFullWeek) {
                                        percentageOfPrice -= (selectedDiscountJSON.discount / 100);
                                    }
                                }
                            }
                            total += item.price * state.children; //update grand total

                            //If more than one child, add discount to this one.
                            

                            return item.price * percentageOfPrice; //Emit discounted cost for futher tallying
                        }).reduce((a, b) => a + b, 0) //Sum up results


                }
            )
            .reduce((a, b) => a + b, 0) * state.children
    );
    if( state.includeInsurance ){
        let totalDays = Object.values(state.days).filter(d => Object.keys(d).find(k => d[k])).length;
        let insuanceCost = totalDays * ownProps.insurance * state.children
        total += insuanceCost;
        totalWithDiscount += insuanceCost;
    }

    return {
        discount: total - totalWithDiscount,
        total: totalWithDiscount,
        totalDays: Object.values(state.days).filter(d => Object.keys(d).find(k => d[k])).length,
        conDet
    }
})(function FlexiTotal(props) {
    _PRICE_CALLBACK(isNaN(props.total) ? 0 : props.total, props.totalDays);
    return <div className="total">
        {props.discount > 0 ? <p>Discount &pound;{props.discount.toFixed(2)}</p> : null}
        {props.discount > 0 && props.discount.discountJson && props.discount.discountJson.name != undefined ? <p>{props.discount.discountJson.name}</p> : null}
        <p>Total &pound;<span className="value">{isNaN(props.total) ? "0.00" : props.total.toFixed(2)}</span> </p>
    </div>
}

)

let _PRICE_CALLBACK = () => { }

export function renderDaySelector(element, options, priceCallback = () => { }) {
    let {
        isAcademy = false,
        booking_items = [],
        course_dates = [],
        blockedDays = [],
        start,
        end,
        discountJson,
        accountChildren = [],
        guardian,
        insurance
    } = options;
    _PRICE_CALLBACK = priceCallback;

    let store = getStore(course_dates, booking_items, blockedDays, false /*isAcademy */);

    let dStart = new Date(start);
    let dEnd = new Date(end);
    let activeTerms = TERM_DATA.filter(term => (
        (
            dStart <= term.from &&
            term.from <= dEnd
        ) ||
        (
            term.from <= dStart &&
            dStart <= term.to
        )
    )
    ).filter((term) => {
        return Object.keys(store.getState().days).filter(d => {
            let dd = new Date(d);
            return dd >= term.from && dd <= term.to
        }).length > 0
    })

    if (course_dates.length > 0) {
        ReactDOM.render(
            <Provider store={store}>
                <div>
                    <ChildrenEditor
                        accountChildren={accountChildren}
                        guardian={guardian}
                        onCountChange={newChildCount => {
                            store.dispatch({ type: "SETCHILDREN", children: newChildCount });
                        }}
                    />
                    
                    {(() => {
                        if (isAcademy) {
                            return <FlexiAcademy discount={{ discountJson }} activeTerms={activeTerms} isMobile={false} store={store} insurance={insurance} />
                        } else {
                            return <FlexiSelector discount={{ discountJson }} activeTerms={activeTerms} isMobile={false} store={store} insurance={insurance} />
                        }
                    })()}
                </div>
            </Provider>
            , element);
    } else {
        ReactDOM.render(<p>No available dates found, this course may have ended.</p>, element);
    }
    return function (newChildCount) {
        store.dispatch({ type: "SETCHILDREN", children: newChildCount });
    }
}



// WEBPACK FOOTER //
// ./flexi/main.jsx